/**
 * EnvUtils
 *
 * From: 1.0.0
 * @packageDocumentation
 */

import { ReactText } from 'react';

/**
 * 指定されたキーの環境変数を取得する
 *
 * @param variableKey 環境変数キー
 * @param defaultValue デフォルト値 (未指定の場合は undefined)
 */
const PREFIX = 'REACT_APP';
export const getEnv = (
  variableKey: string,
  defaultValue: ReactText | undefined = undefined
) => process.env[`${PREFIX}_${variableKey}`] || defaultValue;

/**
 * Environment Variables
 */
export const env = {
  /**
   * Operating Environment
   *
   * default: PRODUCTION
   */
  ENVIRONMENT: getEnv('ENVIRONMENT', 'PRODUCTION') as
    | 'DEVELOPMENT'
    | 'STAGING'
    | 'PRODUCTION',
  /**
   * Application Name
   *
   * default: APP
   */
  APP_NAME: getEnv('APP_NAME', 'APP') as string,
  /**
   * Application Root
   *
   * default: /
   */
  APP_ROOT: getEnv('APP_ROOT', '/') as string,
  /**
   * Auth Method
   *
   * default: undefined
   */
  AUTH_METHOD: getEnv('AUTH_METHOD') as string | undefined,
  /**
   * OIDC PKCE Method
   *
   * default: S256
   */
  OIDC_PKCE_METHOD: getEnv('OIDC_PKCE_METHOD', 'S256') as string,
  /**
   * BASE_API Endpoint
   *
   * default: /
   */
  BASE_API_ENDPOINT: getEnv('BASE_API_ENDPOINT', '/') as string,
  /**
   * Request Credentials
   *
   * default: same-origin
   */
  REQUEST_CREDENTIALS: getEnv('REQUEST_CREDENTIALS', 'same-origin') as string,
  /**
   * ZipCode to Address API Endpoint
   *
   * default: /
   */
  ZIP_CODE_TO_ADDRESS_API_ENDPOINT: getEnv(
    'ZIP_CODE_TO_ADDRESS_API_ENDPOINT',
    '/'
  ) as string,
  /**
   * UI バージョン
   *
   * default: undefined
   */
  UI_VERSION: getEnv('UI_VERSION') as string | undefined,
};
